import LoadingSkeleton from "./LoadingSkeleton";
import MenuItemSkeleton from "./MenuItemSkeleton";
import MenuRowSkeleton from "./MenuRowSkeleton";

export default LoadingSkeleton;
export {MenuItemSkeleton, MenuRowSkeleton};
